import ProduitEcranCible from "../../domain/ProduitEcranCible";

export const workingGirls = new ProduitEcranCible('ctwg', 'Cine Target Working Girls', 'Entrées Working Girls', {
  'S2001': {audience: 280050, tarif: 172230},
  'S2002': {audience: 203468, tarif: 81340},
  'S2003': {audience: 242518, tarif: 96950},
  'S2004': {audience: 285915, tarif: 114290},
  'S2005': {audience: 325279, tarif: 230050},
  'S2006': {audience: 411467, tarif: 303660},
  'S2007': {audience: 412694, tarif: 329950},
  'S2008': {audience: 406436, tarif: 324950},
  'S2009': {audience: 352073, tarif: 238180},
  'S2010': {audience: 277666, tarif: 187840},
  'S2011': {audience: 276059, tarif: 152800},
  'S2012': {audience: 246360, tarif: 136360},
  'S2013': {audience: 309702, tarif: 190470},
  'S2014': {audience: 285974, tarif: 202260},
  'S2015': {audience: 294051, tarif: 207970},
  'S2016': {audience: 311008, tarif: 219960},
  'S2017': {audience: 398076, tarif: 318260},
  'S2018': {audience: 295201, tarif: 190630},
  'S2019': {audience: 243044, tarif: 134520},
  'S2020': {audience: 243965, tarif: 135030},
  'S2021': {audience: 297355, tarif: 201160},
  'S2022': {audience: 247978, tarif: 160130},
  'S2023': {audience: 292955, tarif: 180170},
  'S2024': {audience: 228768, tarif: 112550},
  'S2025': {audience: 263746, tarif: 129760},
  'S2026': {audience: 313704, tarif: 327980},
  'S2027': {audience: 332108, tarif: 265520},
  'S2028': {audience: 316229, tarif: 213930},
  'S2029': {audience: 323652, tarif: 238860},
  'S2030': {audience: 280997, tarif: 172810},
  'S2031': {audience: 302683, tarif: 186150},
  'S2032': {audience: 340047, tarif: 209130},
  'S2033': {audience: 278918, tarif: 171530},
  'S2034': {audience: 268824, tarif: 107460},
  'S2035': {audience: 236498, tarif: 101810},
  'S2036': {audience: 245412, tarif: 150930},
  'S2037': {audience: 243163, tarif: 157020},
  'S2038': {audience: 273730, tarif: 202010},
  'S2039': {audience: 257388, tarif: 189950},
  'S2040': {audience: 245816, tarif: 151180},
  'S2041': {audience: 252577, tarif: 155330},
  'S2042': {audience: 334393, tarif: 246780},
  'S2043': {audience: 390096, tarif: 311880},
  'S2044': {audience: 341560, tarif: 252070},
  'S2045': {audience: 304776, tarif: 206180},
  'S2046': {audience: 311352, tarif: 220200},
  'S2047': {audience: 310486, tarif: 219590},
  'S2048': {audience: 334233, tarif: 236390},
  'S2049': {audience: 334219, tarif: 308320},
  'S2050': {audience: 337783, tarif: 332380},
  'S2051': {audience: 448851, tarif: 455470},
  'S2052': {audience: 470462, tarif: 477400}
});
